import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const PlusButton = ({ onClick, label }: { onClick: () => void; label: string }) => {
  return (
    <Button
      variant="outlined"
      color={'primary'}
      onClick={onClick}
      startIcon={<AddIcon />}
      sx={{ alignSelf: 'flex-start', marginY: 1, marginLeft: 1.5 }}>
      {label}
    </Button>
  );
};
